import React from "react";
import {
  SideBarContainer,
  Icon,
  CloseIcon,
  SideBarLink,
  SideBarWrapper,
  SideBarMenu,
  SideBarFooter,
} from "./sidebarElements";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/projects", label: "Portfolio" },
  { to: "/builders", label: "Founders" },
  { to: "/team", label: "Team" },
];

export default function SideBar({ $isopen, toggle }) {
  return (
    <SideBarContainer $isopen={$isopen} onClick={toggle}>
      <Icon onClick={toggle} role="button" aria-label="Close menu">
        <CloseIcon />
      </Icon>
      <SideBarWrapper>
        <SideBarMenu>
          {LINKS.map(({ to, label }) => (
            <li key={to}>
              <SideBarLink to={to} onClick={toggle}>
                {label}
              </SideBarLink>
            </li>
          ))}
        </SideBarMenu>
      </SideBarWrapper>
      <SideBarFooter>
        <a href="mailto:inquiries@vitalforcecapital.com">
          inquiries@vitalforcecapital.com
        </a>
      </SideBarFooter>
    </SideBarContainer>
  );
}
